import { API } from 'aws-amplify';
import store from '../configureStore';
import { config } from '../config/Config';

export const getJobsForProject = async (projectId) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
    user: { id: userId },
  } = store.getState();

  const init = {
    headers: header,
  };

  return API.get(
    config.apiGateway.NAME,
    `/shake/job?gid=${currentUserGroup}&parent=${projectId}`,
    init,
  );
};

export const getTemplates = async () => {
  const {
    project,
    workspace: { currentUserGroup },
    user: { id: userId },
  } = store.getState();

  const init = {
    headers: project.header,
  };
  return API.get(config.apiGateway.NAME, `/shake/template?gid=${currentUserGroup}`, init);
};

export const createJob = async (jobData) => {
  const {
    project: { header, projectId },
    workspace: { currentUserGroup },
  } = store.getState();

  const body = { ...jobData, project_id: projectId, customer_id: currentUserGroup };

  const init = {
    headers: header,
    body: body,
  };

  return API.post(config.apiGateway.NAME, `/shake/add-job?gid=${currentUserGroup}`, init);
};

export const getJob = async (jobId) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();

  const init = {
    headers: header,
  };

  return API.get(config.apiGateway.NAME, `/shake/job?id=${jobId}&gid=${currentUserGroup}`, init);
};



 